import { __assign } from 'tslib';
import { buttons } from './buttons.js';
import { iconButtons } from './icon-buttons.js';

var _a, _b, _c;
var pagination = {
    base: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
    },
};
var paginationButton = {
    base: __assign(__assign({}, buttons.base), { width: "auto", border: "none" }),
    variants: {
        tone: {
            white: {
                backgroundColor: "white",
                color: "text",
                ":hover:not(:disabled):not([data-disabled='true'])": {
                    backgroundColor: "brandDark.20",
                },
            },
            black: {
                backgroundColor: "brandDark.100",
                color: "white",
            },
        },
        size: __assign({}, (_a = buttons.variants) === null || _a === void 0 ? void 0 : _a.size),
    },
    defaultProps: {
        size: "md",
        look: "",
        tone: "white",
        rounded: false,
    },
};
var paginationArrowButton = {
    base: __assign(__assign({}, iconButtons.base), { border: "none", backgroundColor: "white", color: "text", ":hover:not(:disabled):not([data-disabled='true'])": {
            backgroundColor: "black.10",
        }, ":disabled, &[data-disabled='true']": {
            opacity: 0.2,
            cursor: "not-allowed",
        } }),
    variants: {
        look: {},
        tone: {},
        size: __assign({}, (_b = iconButtons.variants) === null || _b === void 0 ? void 0 : _b.size),
    },
    defaultProps: {
        size: "md",
        look: "",
        tone: "",
        rounded: false,
    },
};
var buttonSize = (_c = buttons.variants) === null || _c === void 0 ? void 0 : _c.size;
var paginationEllipsis = {
    base: __assign(__assign({}, buttons.base), { width: "var(--button-height)", border: "none", backgroundColor: "white", color: "text", cursor: "default" }),
    variants: {
        look: {},
        tone: {},
        size: __assign(__assign({}, buttonSize), { xs: __assign(__assign({}, buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.xs), { padding: 0 }), sm: __assign(__assign({}, buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.sm), { padding: 0 }), md: __assign(__assign({}, buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.md), { padding: 0 }), lg: __assign(__assign({}, buttonSize === null || buttonSize === void 0 ? void 0 : buttonSize.lg), { padding: 0 }) }),
    },
    defaultProps: {
        size: "md",
        look: "",
        tone: "",
        rounded: false,
    },
};

export { pagination, paginationArrowButton, paginationButton, paginationEllipsis };
//# sourceMappingURL=pagination.js.map
